const Cookie = require('cookie-universal')

export default {
  install(Vue, options) {
    Vue.prototype.$cookies = new Cookie()
  }
}
